import { render, staticRenderFns } from "./payOrder.vue?vue&type=template&id=4afa6c63&scoped=true"
import script from "./payOrder.vue?vue&type=script&lang=js"
export * from "./payOrder.vue?vue&type=script&lang=js"
import style0 from "./payOrder.vue?vue&type=style&index=0&id=4afa6c63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa6c63",
  null
  
)

export default component.exports